<template>
  <b-container>
    <h1 v-translate>Edit Profile</h1>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <profile-navigation />
      </div>
      <div class="col-md-9 personal-info">
        <div class="row">
          <h3 class="col-12" v-translate>Personal Addresses</h3>
          <p class="col-12 mb-4" v-translate>Here you can create and manage all your personal locations with their contact persons to easily re-use them when posting a new shipping. All locations will appear into the address form inputs.</p>
          <div class="form-group col-4">
            <b-btn v-b-modal.modalEnterAddress v-translate>Add new address</b-btn>
          </div>
        </div>
        <div>
          <address-list ref="address_list" />
        </div>
      </div>
    </div>
    <b-modal id="modalEnterAddress" ref="modalEnterAddress" :hide-footer="true">
      <div slot="modal-title" v-translate>Create a new address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
        <add-address @cancel="closeModalAddress" @success="successModalAddress" />
    </b-modal>
  </b-container>
</template>
<script>
import ProfileNavigation from '@/components/ProfileNavigation'
import AddressList from '@/components/AddressList'
import AddAddress from '@/components/AddAddress'

export default {
  name: 'ProfileAddressesPage',
  title() {
    return this.$gettext('Addresses « Edit Profile')
  },
  components: {
    AddressList,
    AddAddress,
    ProfileNavigation
  },
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  methods: {
    closeModalAddress() {
      this.$refs.modalEnterAddress.hide()
    },
    successModalAddress() {
      this.$refs.modalEnterAddress.hide()
      this.$refs.address_list.fetchAddresses()
    }
  }
}
</script>
